module.exports = __webpack_public_path__ + "static/media/tint_car.c2d2edd3.svg";